import { ActionType, createReducer } from 'typesafe-actions';

import { AppViews } from 'endpoints';
import * as actions from '../actions/authAgency';
import { AuthAgencyState, TypeLoginSucceededPayload } from '../types/authAgency';

const authData = JSON.parse(localStorage.getItem('authAgencyData') || '{}');

const initialState: AuthAgencyState = {
  token: authData?.token || null,
};

export const authAgencyReducer = createReducer<TypeLoginSucceededPayload, ActionType<typeof actions>>(initialState)
  .handleAction([actions.loginAgencyRequest.success, actions.setAgencyTokenPayload], (state, { payload }) => {
    return {
      ...state,
      token: payload?.token,
    };
  })
  .handleAction(actions.logoutAgency, (state) => {
    localStorage.removeItem('authAgencyData');
    return {
      ...state,
      token: '',
    };
  });
